module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "activity-product-card"
  }, [_c('v-flex', {
    staticClass: "product-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "product-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "product-image",
    style: ({
      'background-image': 'url(' + _vm.item.covers[0].cover.thumb.url + ')'
    })
  }), _vm._v(" "), (_vm.priceShow) ? _c('v-flex', {
    staticClass: "product-actions",
    attrs: {
      "xs12": "",
      "relative": ""
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    },
    on: {
      "click": function($event) {
        _vm.showMerchModal = true
      }
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showMerchModal) ? _c('merch-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dimissMerchModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4142277e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activityproductcard.vue
// module id = 1695
// module chunks = 180